import React from "react";
// import { toast, Toaster } from "sonner";

interface ButtonProps {
  label: string;
  showDot: boolean;
  onClick: () => void;
}

const Button = (props: ButtonProps) => {
  const { label, showDot, onClick } = props;

  return (
    <button
      className="relative inline-flex h-12 overflow-hidden rounded-full p-[1px] focus:outline-none focus:ring-2 focus:ring-slate-400 focus:ring-offset-2 focus:ring-offset-slate-50"
      onClick={onClick}
    >
      {showDot && (
        <span className="absolute inset-0 flex h-full w-full items-center justify-center">
          <span className="animate-ping absolute inline-flex h-3 w-3 rounded-full bg-sky-400 opacity-75"></span>
          <span className="relative inline-flex rounded-full h-3 w-3 bg-sky-500"></span>
        </span>
      )}
      <span className="absolute inset-[-1000%] animate-[spin_2s_linear_infinite] bg-[conic-gradient(from_90deg_at_50%_50%,#FFBABA_0%,#D8000C_50%,#FFBABA_100%)]" />
      <span className="inline-flex h-full w-full cursor-pointer items-center justify-center rounded-full bg-slate-950 px-6 py-1 text-base font-medium text-white backdrop-blur-3xl">
        {label}
      </span>
    </button>
  );
};

export default Button;
